import { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';

import LocationSearch from './LocationSearch';

function LocationSearchControlPortal({ map }) {
  const [targetElement, setTargetElement] = useState(null);

  useEffect(() => {
    if (!map) {
      setTargetElement(null);
      return undefined;
    }

    let animationFrameId;

    const resolveTarget = () => {
      const element = document.querySelector('.maplibregl-ctrl-location-search-placeholder');

      if (element) {
        setTargetElement(element);
        return;
      }

      animationFrameId = window.requestAnimationFrame(resolveTarget);
    };

    resolveTarget();

    return () => {
      if (animationFrameId) {
        window.cancelAnimationFrame(animationFrameId);
      }
    };
  }, [map]);

  if (!targetElement || !map) {
    return null;
  }

  return createPortal(<LocationSearch map={map} />, targetElement);
}

export default LocationSearchControlPortal;
